import { InfluencerSectionDSContent } from '@src/components/blocks/influencer-section-ds'
import { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import type InfluencerDetails from '@src/quince-site-common/src/domains/InfluencerDetails'
import RichText from '@src/quince-site-common/src/domains/RichText'

import { toRichText } from '../widget-utils'

import { adaptInfluencerCard } from './influencer-section.adapter'

import type {
  InfluencerCardData,
  InfluencerSectionWidgetData,
} from '@lastbrand/storefront-proto-registry/api/v1/widget'

// Widget.widgets is a recursive proto type TS can't resolve through Omit<Widget,'data'>;
// read nested INFLUENCER_CARD data via a narrow cast.
interface InfluencerNestedWidget {
  data?: { influencerCard?: InfluencerCardData }
}

export function InfluencerSectionWidgetDS(props: PLTypedWidgetProps<InfluencerSectionWidgetData>) {
  const data = props.data.influencerSectionData

  const headingRichTextProps = RichText.makeRichTextProps(toRichText(data?.heading))
  const descriptionRichTextProps = RichText.makeRichTextProps(toRichText(data?.description))

  const nestedWidgets = (props as unknown as { widgets?: InfluencerNestedWidget[] }).widgets
  const influencers: InfluencerDetails[] = (Array.isArray(nestedWidgets) ? nestedWidgets : [])
    .map(widget => widget.data?.influencerCard)
    .filter((card): card is InfluencerCardData => !!card)
    .map(adaptInfluencerCard)

  return (
    <InfluencerSectionDSContent
      influencers={influencers}
      headingRichTextProps={headingRichTextProps}
      descriptionRichTextProps={descriptionRichTextProps}
    />
  )
}
